import axios from 'axios'

export const payment = {
  namespaced: true,
  state: () => ({
    methods: {},
    detail: {},
    insuranceDetail: {},
    statusCode: 0
  }),

  mutations: {
    setDetail(state, detail) {
      state.detail = detail
    },
    setStatus(state, status) {
      state.statusCode = status
    },
    setInsuranceDetail(state, detail) {
      state.insuranceDetail = detail
    },
    setMethods(state, methods) {
      state.methods = methods
    }
  },

  actions: {
    async create({ commit }, payload) {
      await axios.post('/payments/', payload).then(res => {
        commit('setDetail', res.data)
        commit('setStatus', res.status)
      })
    },
    async getMethods({ commit }, payload) {
      await axios.get(`/payment-methods/?event=${payload.id}`).then(res => {
        commit('setMethods', res.data)
      })
    },
    setDefaultPayment({ commit }, payload) {
      commit('setDetail', payload.detail)
      commit('setStatus', payload.status)
    }
  }
}
